
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[m_alias]/[mid]",
      function () {
        return require("private-next-pages/m/[m_alias]/[mid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[m_alias]/[mid]"])
      });
    }
  